import deductionConfigAddCtrl from "./deductionConfigAddCtrl"
import deductionRuleCtrl from "./deductionRuleCtrl"

class deductionConfigCtrl {
    constructor($scope, httpRequest, $uibModal,logger, sweetalert) {
        $scope.datas = []
        $scope.active = 1
        $scope.tabChange = function (inx){
            $scope.active = inx
            $scope.datas = []
            $scope.totalItems = 0
            if($scope.active === 2){
                $scope.param.pageNum = 1
                $scope.param.pageSize = 10
            }
            $scope.queryList()
        }
        const types = ['department_no','ivat_inv_type']
        $scope.deductionType = [{enumCode:'1',enumName:'抵扣勾选'},{enumCode:'2',enumName:'计算抵扣'}]
        $scope.deductionFlag = [{enumCode:'0',enumName:'不允许'},{enumCode:'1',enumName:'允许'}]
        $scope.mnCompareRule = [{enumCode:'0',enumName:'等于'},{enumCode:'1',enumName:'包含'},{enumCode:'2',enumName:'不包含'}]
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.param = {
            param: {
                invoiceType: '',
                schemeName: '',
                useScope: '',
            },
            pageNum: 1,
            pageSize: 10,
        }
        $scope.addScheme = function addScheme(){
            if($scope.active === 1){
                return $uibModal.open({
                    templateUrl: 'deduction-scheme-add-dialog.html',
                    controller: deductionConfigAddCtrl,
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-md',
                }).result.then(() => {
                    $scope.queryList()
                })
            }else{
                return $uibModal.open({
                    templateUrl: 'deduction-rule-add-dialog.html',
                    controller: deductionRuleCtrl,
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-big',
                }).result.then(() => {
                    $scope.queryList()
                })
            }

        }
        $scope.queryList = function queryList() {
            if ($scope.active === 1){
                httpRequest.post_queryDeductionScheme().then((res) => {
                    $scope.datas = res.data.value.list
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                    $scope.param.pageSize = res.data.value.pageSize
                })
            }else{
                httpRequest.post_queryDeductionRuleList($scope.param).then((res) => {
                    $scope.datas = res.data.value.list
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                    $scope.param.pageSize = res.data.value.pageSize
                })
            }
        }
        $scope.queryList()
        $scope.tableDropdownConfig = [
            {
                label: '删除',
                handler(item) {
                    sweetalert
                        .confirm('确认删除', '删除后对应的所有规则将失效，确定要删除吗？')
                        .then(() => {
                            httpRequest
                                .get_delDeductionScheme(item.id, '删除成功')
                                .then((res) => {
                                    if (res.data.success) {
                                        $scope.queryList();
                                    }
                                });
                        });

                },
                showWhile(item) {
                    return item.defaultFlag === 0 //默认方案不允许删除
                },
            }
        ]

        $scope.tableDropdownRuleConfig = [
            {
                label: '删除',
                handler(item) {
                    sweetalert
                        .confirm('确认删除', '删除后对应的规则将失效，确定要删除吗？')
                        .then(() => {
                            httpRequest
                                .get_delDeductionRule(item.configId, '删除成功')
                                .then((res) => {
                                    if (res.data.success) {
                                        $scope.queryList();
                                    }
                                });
                        });

                },
                showWhile(item) {
                    return item.deleteFlag === 0 //默认方案不允许删除
                },
            }
        ]

        $scope.pageChanged = function () {
            $scope.queryList()
        }
    }
}

deductionConfigCtrl.$inject = ['$scope', 'httpRequest','$uibModal', 'logger', 'sweetalert']

export default deductionConfigCtrl



// WEBPACK FOOTER //
// ./src/app/input/basedata/deductionConfig/deductionConfigCtrl.js